import React from 'react';
import Auth from 'services/Auth';

let lastMove = Date.now();

export default class UserActivityObserver extends React.Component {

  mouseMoved() {
    const now = Date.now();
    if (!lastMove || (now - lastMove) < 600000) {
      return;
    }
    lastMove = now;
    Auth.refreshToken().then(() => {}).catch((errors) => {
      alert(errors.join(' '));
    });
  }

  render() {
    return <div id="app" onMouseMove={this.mouseMoved}>{this.props.children}</div>;
  }

}